import "VSS/LoaderPlugins/Css!LegacyBoardConfiguration";

import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");
import CardStyleCustomization_NO_REQUIRE = require("Agile/Scripts/Card/CardCustomizationStyle");
import TeamServices = require("TfsCommon/Scripts/Team/Services");
import * as Events_Action from "VSS/Events/Action";
import { Actions } from "Presentation/Scripts/TFS/TFS.Configurations.Constants";
import { registerCommonTemplates } from "Agile/Scripts/Board/Templates";
import { registerTaskboardSettingsForIterationLevel } from "Agile/Scripts/Settings/TaskboardCommonSettingsConfiguration";
import Configurations = require("Presentation/Scripts/TFS/TFS.Configurations");
import { IBugSettingData } from "Agile/Scripts/Admin/TeamSettings";

/**
 * Used only by New Web Platform Sprints Hub
 */
export function launchTaskboardCommonSettingsDialog(
    teamId: string,
    currentUserTeamPermissions: TeamServices.ITeamPermissions,
    showBacklogVisibilitiesTab: boolean,
    fieldOptions: BoardsSettingsControls.IFieldSettingsControlOptions,
    styleOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
    bugSettingData: IBugSettingData
) {

    registerCommonTemplates();
    const closeHandler = (actionArgs: any, next: Function) => {
        clearRegistration();
        Events_Action.getService().unregisterActionWorker(Actions.CLOSE_COMMON_CONFIGURATION, closeHandler);
    }

    // Clearing just incase the closeHandler was not called
    clearRegistration();

    // Register the tabs
    registerTaskboardSettingsForIterationLevel(teamId, currentUserTeamPermissions, showBacklogVisibilitiesTab, fieldOptions, styleOptions, bugSettingData);

    // Clear the tabs on close
    Events_Action.getService().registerActionWorker(Actions.CLOSE_COMMON_CONFIGURATION, closeHandler, Events_Action.ActionService.MaxOrder);

    // Launch the dialog
    Events_Action.getService().performAction(Actions.LAUNCH_COMMON_CONFIGURATION, { hideBacklogVisibilitiesTab: false });
}



function clearRegistration() {
    Configurations.TabControlsRegistration.clearRegistrations();
}